export default __webpack_public_path__ + "static/papas_fritas-c1445ece9fad1d6f50f297a7f654141b.jpg";